import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import MeetTheTeam from './components/MeetTheTeam';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import ServiceArea from './components/ServiceArea';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Services />
      <WhyChooseUs />
      <MeetTheTeam />
      <Testimonials />
      <FAQ />
      <ServiceArea />
      <Contact />
      <Footer />

      {/* Sticky Mobile Call Now Button */}
      <a
        href="tel:+19412233052"
        className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 md:hidden flex items-center gap-2 bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white font-bold text-lg px-8 py-4 rounded-full shadow-2xl whitespace-nowrap cursor-pointer transition-all duration-200"
        style={{ boxShadow: '0 8px 32px rgba(249,115,22,0.45)' }}
      >
        <span className="w-6 h-6 flex items-center justify-center">
          <i className="ri-phone-fill text-xl"></i>
        </span>
        Call Now — (941) 223-3052
      </a>
    </div>
  );
}
